export enum MyAccountEnvironment {
  'prod' = 'prod',
  'dev' = 'dev',
}
